import { SignupFlow } from './routes/signup-flow.js';

export function App() {
  return (
    <div data-testid="signup-root" className="min-h-screen">
      <SignupFlow />
    </div>
  );
}
